import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IDisposable } from 'core/dynamic-form';
import { filter, map } from 'rxjs';
import { RemoteActivityService } from '../../../remotes/remote-activity.service';
import { RemoteTaskService } from '../../../remotes/remote-task.service';
import { ActorSplugInfoDialogService } from '../../2-select-activities-step/activity-collection/activity-item/actor-splug-info-dialog.service';
import { SignatureService } from '../signature/signature.service';
import { TaskCollectionService } from '../task-collection.service';
import { SignatureOptionsDialogService } from './signature-options-dialog.service';
import { SignatureOptionsService } from './signature-options.service';

export interface ISignatureOptionsData {
  signatureService: SignatureService,
  signatureOptionsDialogService: SignatureOptionsDialogService,
  signatureCollectionService: TaskCollectionService,
  actorSplugInfoDialogService: ActorSplugInfoDialogService,
  remoteTaskService: RemoteTaskService,
  remoteActivityService: RemoteActivityService
}

@Component({
  selector: 'ss-signature-options',
  templateUrl: './signature-options.component.html',
  styleUrls: ['./signature-options.component.css'],
  providers: [
    SignatureOptionsService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureOptionsComponent implements OnInit {
  private readonly _disposables: IDisposable[] = [];

  readonly allowedSignatureTypesSubject = this._signatureOptionsService.allowedSignatureTypesSubject;
  readonly activityObs = this._signatureOptionsService.activityObs;

  readonly actorObs = this.activityObs.pipe(
    filter(Boolean),
    map(activity => activity.actor),
    filter(Boolean),
  )

  readonly backgroundObs = this._signatureOptionsService.backgroundObs;

  private _signatureOptionsDialogService = this._signatureOptionsService.data.signatureOptionsDialogService;

  constructor(
    private readonly _signatureOptionsService: SignatureOptionsService,

  ) {

  }

  ngOnInit(): void {

  }

  close() {
    this._signatureOptionsDialogService.close();
  }

  save() {
    this._signatureOptionsService.save();
  }

  ngOnDestroy() {
  }

}
